import React from "react";
import "../../src/App.css";

function PrivacyPolicy() {
  return (
    <div className="page-content">
      <h1>Privacy Policy</h1>
      <p>
        <strong>Last Updated:</strong> May 13, 2025
      </p>
      <p>
        At multido.com, we value your privacy and are committed to protecting
        your personal information. This Privacy Policy explains how we collect,
        use, disclose, and safeguard your data when you use our application.
      </p>
      <h2>1. Information We Collect</h2>
      <p>
        We collect the following types of information:
        <ul>
          <li>
            <strong>Personal Information:</strong> When you use multido.com, we
            may collect data such as your tasks, to-do lists, and settings,
            which are stored locally in your browser via localStorage.
          </li>
          <li>
            <strong>Usage Data:</strong> We may collect anonymized data on how
            you interact with the app (e.g., features used, time spent) to
            improve our services.
          </li>
          <li>
            <strong>Imported Data:</strong> If you import a JSON file, we
            process the data contained within it (e.g., tasks, settings) to
            restore your app state.
          </li>
        </ul>
      </p>
      <h2>2. How We Use Your Information</h2>
      <p>
        We use your information to:
        <ul>
          <li>
            Provide and maintain the functionality of multido.com (e.g., saving
            and importing tasks).
          </li>
          <li>Improve our app by analyzing usage patterns.</li>
          <li>Ensure the security and integrity of our services.</li>
        </ul>
      </p>
      <h2>3. Data Storage and Security</h2>
      <p>
        Your data is stored locally in your browser using localStorage. We do
        not transmit your data to our servers unless explicitly requested (e.g.,
        via a future API feature). We implement reasonable measures to protect
        your data, but please note that no method of storage is 100% secure.
      </p>
      <h2>4. Sharing Your Information</h2>
      <p>
        We do not share your personal information with third parties except:
        <ul>
          <li>
            With your consent (e.g., if you choose to export and share your
            data).
          </li>
          <li>To comply with legal obligations.</li>
        </ul>
      </p>
      <h2>5. Your Rights</h2>
      <p>
        You have the right to:
        <ul>
          <li>Export your data using the "Save All" feature.</li>
          <li>Delete your data using the "Wipe All" feature.</li>
        </ul>
      </p>
      <h2>6. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you
        of changes by updating the "Last Updated" date at the top of this page.
      </p>
      <h2>7. Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy, please contact us at{" "}
        <a href="mailto:support@multido.com">support@multido.com</a>.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
